import React from 'react';
import PrivateRoute from 'PrivateRoutes';
const REPORT = React.lazy(()=> import(/* webpackChunkName: "MessageCDRReport" */'./components'));

const routes = () =>{ 
  console.log(`routes---- /reporting/message-cdr-report`)
  return (
  <PrivateRoute exact path="/reporting/message-cdr-report" component={REPORT} />
);
}

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/MessageCDRReport/routes.js